module.exports = __webpack_public_path__ + "img/TUR-B-1-II.0580a0b4.png";